import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

var marked = require('marked');
marked.setOptions({
  gfm: true,
  tables: true,
  breaks: true,
  sanitize: true
});

// import defaultImage from '../../images/stock-student.jpg';

const People_Item = (props) => (
      <PersonCard >
        <FlexContainer>
          {props.person.image &&
            <ImageContainer>
                <PersonImage src={`${props.person.image.file.url}?w=500`}/>
            </ImageContainer>
          }
          <div style={{flex: '1'}}>
            <PersonName>{props.person.name}</PersonName>
            <PersonPosition>{props.person.position}</PersonPosition>
            <PersonInstitution>{props.person.institution} ({props.person.year})</PersonInstitution>
            {props.person.description &&
              <PersonDetails
                dangerouslySetInnerHTML={{__html: marked(props.person.description.description, {sanitize: true})}}>
              </PersonDetails>
            }
          </div>
        </FlexContainer>
      </PersonCard>
);

export default People_Item;


const PersonCard = styled.div`
  background: linear-gradient(rgba(251, 251, 251,1),rgba(255, 255, 255,1));
  padding: 20px;
  margin: 0px 10px 20px;
  border: 1px solid #eee;
  &:last-of-type {
    margin-bottom: 20px;
  }
  width: 100%;
  max-width: 800px;
  @media (max-width: 600px) {
    max-width: 450px;
  }
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const PersonImage = styled.div`
  height: 100%;
  width: 100%;
  background: ${props =>
  props.src && `url(${props.src})`
  };
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const ImageContainer = styled.div`
  width: 200px;
  height: 200px;
  margin-right: 20px;
  flex: 0 1 200px;
  @media (max-width: 600px) {
    width: 100%;
    margin: 0 0 20px;
  }
`

const PersonName = styled.h2`
  font-weight: 300;
  line-height: 1.8rem;
  font-size: 1.5rem;
  margin: 0px 0px .5rem;
`

const PersonInstitution = styled.p`
  line-height: 1.5rem;
  font-size: 1.1rem;
  margin: 0px 0px .5rem;
  font-weight: 400;
  color: rebeccapurple;
  opacity: 0.8;
`;

const PersonPosition = styled.p`
  line-height: 1.5rem;
  font-size: 1.1rem;
  margin: 0px 0px .5rem;
  font-weight: 500;
  opacity: 0.9;
`;
//
const PersonDetails = styled.p`
  line-height: 1.5rem;
  font-size: 1.1rem;
  font-weight: 300;
  margin: 0px 0px 0;
  opacity: 0.8;
  & p:last-of-type {
    margin-bottom: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/People_Item/index.js